import { mdiArchiveOutline, mdiArchiveArrowUpOutline } from "@mdi/js"
import type { AddressRow } from "../_shared/_logic/address-table-contract"
import {
  CUSTOMER_REGISTRY_ACTION_TOOLTIP_CLASS,
  customerRegistryActionTooltips,
} from "../../../../../_shared/_logic/customer-registry-action-tooltips"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"

export default function buildRowActions({
  row,
  importLocked = false,
  lockedTooltip,
  onMutate,
}: {
  row: AddressRow
  importLocked?: boolean
  lockedTooltip: string
  onMutate: (row: AddressRow) => void | Promise<void>
}): TableRowAction[] {
  const actions: TableRowAction[] = []

  actions.push({
    id: "action-0",

    label: row.property?.archived_at ? "Wiederherstellen" : "Archivieren",
    onClick: () => {
      if (importLocked) return

      onMutate(row)
    },
    icon: row.property?.archived_at ? mdiArchiveArrowUpOutline : mdiArchiveOutline,
    disabled: importLocked,
    tooltip: importLocked
      ? lockedTooltip
      : row.property?.archived_at
        ? customerRegistryActionTooltips.propertyRestore
        : customerRegistryActionTooltips.propertyArchive,
  })

  return actions
}
